import { Component, Inject, Input, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { AnimationState } from "./animations";
import { animate, style, transition, trigger } from "@angular/animations";
import { MotorQuotationDataService, NewUserVoucherRequest } from "src/app/share/data-service/motor/motor-quotation.data.service";


@Component({
  selector: "app-new-user-gamification",
  templateUrl: "./new-user-gamification.component.html",
  styleUrls: ["./new-user-gamification.component.css"],
  animations: [
    trigger("fade", [
      // Transition when state changes from 'false' to 'true'
      transition('false => true', [
        style({ opacity: 1 }), // Ensure it starts visible
        animate('550ms ease-in', style({ opacity: 1 })) // Smooth fade-in effect
      ]),
    
      // Transition when state changes from 'true' to 'false'
      transition('true => false', [
        animate('550ms ease-in', style({ opacity: 1 })) // Stay visible, but prevent flickering
      ])
    ]),
    trigger("fade2", [
      // Transition when state changes from 'false' to 'true'
      transition('false => true', [
        style({ opacity: 0 }), // Ensure it starts visible
        animate('500ms ease-out', style({ opacity: 1 })) // Smooth fade-in effect
      ]),
    
      // Transition when state changes from 'true' to 'false'
      transition('true => false', [
        animate('500ms ease-out', style({ opacity: 1 })) // Stay visible, but prevent flickering
      ])
    ]),
    trigger('fade3', [
      transition(':enter', [
        style({ opacity: 0 }), // Starts invisible
        animate('500ms ease-in', style({ opacity: 1 })) // Fade in over 500ms
      ]),
      transition(':leave', [
        animate('500ms ease-out', style({ opacity: 0 })) // Fade out over 500ms
      ])
    ])
    ]
})
export class NewUserGamificationComponent implements OnInit {
  description: string;
  index = 0;
  onFadeTransition = false;
  onShowVoucher = false;
  transition = 0;
  hideStep3 = false;
  hideStep2 = true;
  onIndex = 0;
  flagOnce = false;
  userEmail = "";
  discountAmount: number = 0;
  mobileView: boolean = false;
  language = this.translate.currentLang;

  constructor(
    public translate: TranslateService,
    private dialogRef: MatDialogRef<NewUserGamificationComponent>,
    private motorQuotationDataService: MotorQuotationDataService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      email: string;
      vehicleNo: string;
      identityNo: string;
    }
  ) {}

  imageArray = [
    "/assets/image/gamification/money-bag-open-1.png",
    "/assets/image/gamification/money-bag-open-2.png",
    "/assets/image/gamification/money-bag-open-3.png",
    "/assets/image/gamification/money-bag-open-4.png",
    "/assets/image/gamification/money-bag-open-5.png",
  ];

  imageArray2 = [
    "/assets/image/gamification/money-bag-open-1.png",
    "/assets/image/gamification/coin1.png",
    "/assets/image/gamification/coin2.png",
    "/assets/image/gamification/coin3.png",
    "/assets/image/gamification/coin4.png",
  ];


  toogle2 = true;
  count2: number = 0;
  toogle = true;
  count: number = 0;
  onFade(event: any) {
    // After the animation completes (done event), switch images
    this.toogle = !this.toogle; // Toggle state for animation
  
    // Change image only after the fade transition is done
    if (event.fromState && this.onIndex == 1) {
      this.count = (this.count + 1) % this.imageArray.length; // Update image index smoothly
    }
  
    // Additional logic to handle image change
    // if (this.count2 == 0 && this.flagOnce) {
    //   this.onIndex = 2;
    // }
  }
  onFade2(event: any) {
      this.toogle2 = !this.toogle2;
      let request: NewUserVoucherRequest = {
            vehicleNo: this.data.vehicleNo,
            identityNo: this.data.identityNo,
            email: this.data.email,
            language: this.language
          };
      if (event.fromState && this.onIndex == 1) {
        this.count2 = (this.count2 + 1) % this.imageArray2.length;
        this.flagOnce = true;
      }

      if (this.count2 == 0 && this.flagOnce) {   
        //generate voucher code and send email
        if (this.flagOnce == true) {
          this.flagOnce = false;
          this.motorQuotationDataService
          .generateNewUserVoucherCodeSendEmail(
            request

          )
          .subscribe({
            next: (x) => {
              this.discountAmount = x;
              console.log("successfully generate code and send email")
              this.onIndex = 2;
            },
          });
        }
        
      }

  }

  // You can change onIndex as needed to switch between divs
  onImageClick() {
    this.onIndex = (this.onIndex + 1) % 3;  // Toggles between 0, 1, 2
  }

  heroImageArray = [
    "/assets/image/gamification/money-bag.png",
    "https://drscdn.500px.org/photo/277987267/q%3D80_m%3D2000/v2?webp=true&sig=082269b7b07ec17da1847d5c20cffee3a3a91af1f474eb3fd908eba828d5327c"
  ];
  heroActiveImage: string =
    "https://drscdn.500px.org/photo/277987267/q%3D80_m%3D2000/v2?webp=true&sig=082269b7b07ec17da1847d5c20cffee3a3a91af1f474eb3fd908eba828d5327c";
  state = AnimationState.IN;

  onDone(test) {
    this.toggleState();
  }

  onClick() {
    this.toggleState();
  }

  toggleState() {
    this.state =
      this.state === AnimationState.IN ? AnimationState.OUT : AnimationState.IN;
    if (this.state === AnimationState.IN) {
      this.changeToNextImage();
    }
  }

  changeToNextImage() {
    if (this.count == this.heroImageArray.length) this.count = 0;
    this.heroActiveImage = this.heroImageArray[this.count];
    this.count++;
  }

  onSetIndex(i: number) {
    this.index = i;
  }

  ngOnInit(): void {
    if (window.screen.width < 960) {
      this.mobileView = true;
    }
    this.onIndex = 0;
    this.description = this.translate
      .instant("dialog.duplicateFound")
      .replace("{1}", this.data.email.toUpperCase());
      console.log(this.onFadeTransition)
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
